// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// prop-types
import PropTypes from "prop-types";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";

// Van image
import vanStock from "assets/images/cars/van_stock_image.webp";

function VanPromo({ horizontal }) {
  return (
    <Card
      sx={{
        width: "100%",
        overflow: "hidden",
        boxShadow: ({ boxShadows: { xxl } }) => xxl,
        display: "flex",
        flexDirection: horizontal ? "row" : "column",
        alignItems: horizontal ? "center" : "stretch",
      }}
    >
      {/* Image - the stock photo already has its own white padding, so no extra frame here.
          In the horizontal layout the wrapper stretches to the full card height and the van is
          vertically centred, so the badge (pinned to the wrapper's top-left) sits in the clear
          space above the van instead of overlapping it. */}
      <MKBox
        position="relative"
        sx={{
          width: horizontal ? "44%" : "100%",
          flexShrink: 0,
          alignSelf: horizontal ? "stretch" : undefined,
          display: horizontal ? "flex" : "block",
          alignItems: "center",
        }}
      >
        <MKBox
          position="relative"
          sx={{
            width: "100%",
            aspectRatio: "811 / 608",
            overflow: "hidden",
          }}
        >
          <MKBox
            component="img"
            src={vanStock}
            alt="Brand-new 2027 Hyundai Staria van available to rent during your stay"
            sx={{
              position: "absolute",
              inset: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />
        </MKBox>

        {/* "New" badge - pinned to the top-left of the image area, in the space above the van */}
        <MKBox
          display="inline-flex"
          alignItems="center"
          gap={{ xs: 0.4, sm: 0.6 }}
          px={{ xs: 0.9, sm: 1.2 }}
          py={0.4}
          borderRadius="lg"
          sx={{
            position: "absolute",
            top: 12,
            left: 12,
            backgroundColor: "warning.main",
            boxShadow: "0 4px 14px rgba(0, 0, 0, 0.25)",
            whiteSpace: "nowrap",
          }}
        >
          <Icon
            sx={{ color: "#fff", fontSize: { xs: "0.8rem !important", sm: "1rem !important" } }}
          >
            verified
          </Icon>
          <MKTypography
            variant="button"
            sx={{
              color: "#fff",
              fontWeight: 700,
              letterSpacing: 0.5,
              lineHeight: 1,
              fontSize: { xs: "0.6rem", sm: "0.75rem" },
            }}
          >
            NEW 2027 MODEL
          </MKTypography>
        </MKBox>
      </MKBox>

      {/* Copy + call to action */}
      <MKBox
        px={horizontal ? { xs: 2, md: 3 } : 3}
        pt={horizontal ? 2 : 1}
        pb={3}
        sx={{
          textAlign: horizontal ? "left" : "center",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          flex: horizontal ? 1 : "0 1 auto",
        }}
      >
        <MKTypography variant="h5" fontWeight="bold" mb={1}>
          Get our brand new Hyundai Staria
        </MKTypography>
        <MKTypography variant="body2" color="text" mb={2.5}>
          Rent your vehicles directly with us and get free two-way transportation. Get shuttled
          straight to the property where your cars will be waiting for you.
        </MKTypography>
        <MKButton
          variant="gradient"
          color="info"
          fullWidth={!horizontal}
          component="a"
          href="/car-rentals"
          sx={horizontal ? { alignSelf: { xs: "stretch", md: "flex-start" } } : undefined}
        >
          Learn more
          <Icon sx={{ ml: 1 }}>arrow_forward</Icon>
        </MKButton>
      </MKBox>
    </Card>
  );
}

VanPromo.propTypes = {
  horizontal: PropTypes.bool,
};

VanPromo.defaultProps = {
  horizontal: false,
};

export default VanPromo;
